import { createCall, spellbook } from "@sdk/spellbook";

import { withAccountAuthHeaders } from "./apiHelpers";

const endpoint = spellbook("/attendances").DELETE();

export type DeleteAttendancesRequest = typeof endpoint.types.Req;
export type DeleteAttendancesResponse = typeof endpoint.types.Res;

export async function deleteAttendances(attendanceIds: string[]) {
    const uniqueIds = [...new Set(attendanceIds)];
    if (uniqueIds.length === 0) {
        return { errors: null } satisfies DeleteAttendancesResponse;
    }

    const call = createCall(endpoint, (r) => fetch(withAccountAuthHeaders(r)));
    const req: DeleteAttendancesRequest = { attendanceIds: uniqueIds };
    return await call({ req });
}
